import { useState, useEffect } from "react";
import { Button, Modal, Form, Input, Select } from "antd";
import { BankNameOptions } from "../../../constants/helperConstants";
import { formatToUTCDateString } from "../../../utils";

const AddPaymentModal = (props: any) => {
  const {
    isModalOpen,
    assignment,
    onCancel,
    onAddPayment,
    isRefund,
    headerText = "",
    isEditMode,
    onUpdatePayment,
    selectedPayment,
    title
  } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEditMode === true) {
      const paymentDate = formatToUTCDateString(selectedPayment?.payment_date);
      form.setFieldValue("payment_date", paymentDate);
    }
  }, [selectedPayment]);

  useEffect(() => {
    const ecbSurveyCode =
      assignment?.type === "Installation"
        ? assignment?.survey?.ecb_survey_code
        : assignment?.ecb_survey_code;
    if (ecbSurveyCode) {
      form.setFieldValue("payment_party_code", ecbSurveyCode);
    }
    if (isRefund) {
      const amountToRefund = assignment?.amount_to_refund;
      if (amountToRefund) {
        form.setFieldValue("payment_amount", amountToRefund);
      }
    }
  }, [assignment]);

  const onFinish = (values: any) => {
    if (isEditMode) {
      if (isRefund) {
        values["refund_id"] = selectedPayment?.id;
        const data = {
          id: selectedPayment?.payable_id,
          paymentData: { payment: values }
        };
        onUpdatePayment(data, setLoading, form);
      } else {
        values["payment_id"] = selectedPayment?.id;
        const data = {
          id: selectedPayment?.payable_id,
          paymentData: { payment: values }
        };
        onUpdatePayment(data, setLoading, form);
      }
    } else {
      if (isRefund) {
        const data = {
          id: assignment?.id,
          paymentData: { payment: values }
        };
        onAddPayment(data, setLoading, form);
      } else {
        const data = { id: assignment?.id, paymentData: { payment: values } };
        onAddPayment(data, setLoading, form);
      }
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <Modal
      title={isRefund ? `${title} Refund` : `${title} Payment`}
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={false}
      destroyOnClose
    >
      <h4>{headerText}</h4>
      <Form
        name="role_user_form"
        form={form}
        initialValues={isEditMode ? selectedPayment : {}}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="payment_ref_number"
          label="Payment Ref Number"
          rules={[
            { required: true, message: "Please input payment ref number" },
            { min: 1, message: "Payment ref number must be minimum 1 characters." }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="payment_date"
          label="Payment Date"
          rules={[{ required: true, message: "Please select date" }]}
        >
          <Input type="date" max={getCurrentDateTime()} />
        </Form.Item>

        <Form.Item
          name="payment_amount"
          label="Payment Amount"
          rules={[{ required: true, message: "Please input payment amount" }]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item
          label="Payment Party Code"
          name="payment_party_code"
          rules={[{ min: 2, message: "code must be minimum 1 characters." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Bank Name in which payment has been rcvd"
          name="bank_name"
          rules={[{ required: true, message: "Please select bank name" }]}
        >
          <Select
            placeholder="Select Outstation"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(inputValue, option: any) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
            options={BankNameOptions}
          ></Select>
        </Form.Item>

        <Form.Item
          label="Customer VPA"
          name="customer_vpa"
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Payment Gateway ID"
          name="payment_gateway_id"
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Customer Bank"
          name="customer_bank"
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Payment Description"
          name="payment_description"
          rules={[{ max: 100, message: "Payment description can't be more than 100 characters" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Payment RRN"
          name="payment_rrn"
        >
          <Input />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isRefund ? `${title} Refund` : `${title} Payment`}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddPaymentModal;
